/**
 * Тип задания точки. Влияет на подачу в плеере: `choice` показывает
 * варианты, `sensor` — сенсорную мини-игру (подуть/потрясти/наклонить/
 * компас), `cipher` — интерактивный дешифратор, остальные — поле ввода.
 * Проверка ответа одинаковая — по acceptedAnswers локали (для sensor
 * клиент шлёт служебный ответ после успеха мини-игры).
 */
export enum CityQuestChallengeTypeEnum {
    COUNT = 'count',
    RIDDLE = 'riddle',
    OBSERVATION = 'observation',
    CHOICE = 'choice',
    ANAGRAM = 'anagram',
    PHOTO = 'photo',
    TIME_DYNAMIC = 'time_dynamic',
    /** Мини-игра на сенсорах телефона; конфиг — в challenge.sensor. */
    SENSOR = 'sensor',
    /** Шифр с интерактивным UI-дешифратором; конфиг — в challenge.cipher. */
    CIPHER = 'cipher',
    /**
     * AR-охота: символы, «висящие» над местами вокруг игрока, видны через
     * камеру (компасный AR как в раннем Pokemon Go). Конфиг — в
     * challenge.ar_hunt, прогресс сбора — через ar-collect.
     */
    AR_HUNT = 'ar_hunt',
}
